// src/components/LandingPage/Features.js
import React from 'react';
import styled from 'styled-components';

const FeaturesSection = styled.section`
  padding: 5rem 4rem;
  text-align: center;
  background: ${({ theme }) => `${theme.cardBackground}40`};

  h3 {
    font-size: 2.4rem;
    font-weight: 800;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.text};
    letter-spacing: -0.02em;
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;

    .feature-card {
      background: ${({ theme }) => theme.cardBackground};
      border-radius: 12px;
      padding: 2.5rem 2rem;
      box-shadow: 0 4px 20px rgba(0,0,0,0.08);
      border: 1px solid ${({ theme }) => `${theme.text}08`};
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-size: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 40px rgba(88, 166, 255, 0.15);
        border-color: #58a6ff33;
      }

      i {
        font-size: 2.5rem;
        margin-bottom: 1rem;
        color: #58a6ff;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #58a6ff11, #79c0ff11);
        border-radius: 12px;
      }

      h4 {
        margin-bottom: 0.8rem;
        font-size: 1.2rem;
        font-weight: 700;
        color: ${({ theme }) => theme.text};
      }

      p {
        font-size: 0.95rem;
        color: ${({ theme }) => theme.text}88;
        line-height: 1.6;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 3rem 2rem;
    
    h3 {
      font-size: 2rem;
    }
  }
`;

const Features = () => (
  <FeaturesSection id="features">
    <h3>Key Features</h3>
    <p>Everything you need to build a stunning portfolio that stands out to employers and clients</p>
    <div className="features-grid">
      <div className="feature-card">
        <i className="pi pi-pencil"></i>
        <h4>Intuitive Editor</h4>
        <p>Easy-to-use form-based editor for creating and customizing your portfolio without coding.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-file-import"></i>
        <h4>AI Resume Parsing</h4>
        <p>Let our AI instantly parse and auto-fill your portfolio details from your resume.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-palette"></i>
        <h4>Multiple Templates</h4>
        <p>Choose from diverse, professionally-designed templates that match your style and industry.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-check-circle"></i>
        <h4>Real-Time Preview</h4>
        <p>See instant live previews of your changes as you build your portfolio.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-share-alt"></i>
        <h4>Easy Sharing</h4>
        <p>Share your portfolio with custom URLs, generate PDFs, or sync with social media.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-shield"></i>
        <h4>Privacy First</h4>
        <p>Your data is encrypted and secure. Full control over what you share and with whom.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-mobile"></i>
        <h4>Mobile Responsive</h4>
        <p>Your portfolio looks perfect on any device - desktop, tablet, or mobile.</p>
      </div>
      <div className="feature-card">
        <i className="pi pi-bolt"></i>
        <h4>Fast & Reliable</h4>
        <p>Lightning-fast loading times and 99.9% uptime for your online presence.</p>
      </div>
    </div>
  </FeaturesSection>
);

export default Features;
